import { format } from "date-fns";

export const displayDate = (value, locale) => {
    const date = new Date(value);
    var formatedValue = (new Intl.DateTimeFormat(locale || 'fr-FR', { dateStyle: 'short'}).format(date));
    return formatedValue;
}

export const formatDate = (date) => {
    return format(new Date(date), 'yyyy-MM-dd');
}

export const parseDate = (dateStr, fallbackDate = null) => {
    if (!dateStr) return fallbackDate;
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
}
